import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { EpdkErrorDialogComponent } from './error-dialog.component';

@NgModule({
  imports: [
    CommonModule,

    // Angular Material.
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule
  ],
  declarations: [EpdkErrorDialogComponent]
})
export class EpdkErrorDialogModule { }
